import { CalculatorType, Scenario } from 'spw-redux/modules/calculators/types';
import { IBuilding } from 'spw-redux/modules/projects/types';
import { GROWTH_CALCULATORS } from 'spw-constants';
import HeadcountScenario from './HeadcountScenario';
import ProgramScenario, { PlainProgramScenario } from './Scenario';
import ProgramScenarioFactory from './ProgramScenarioFactory';

const getFloor = (floorId: number, building: IBuilding) =>
  building?.floors?.find((floor) => floor.id === floorId);

export default class FloorHeadcountScenario extends HeadcountScenario {
  constructor(apiScenario: Scenario) {
    super(apiScenario);

    const floor = getFloor(apiScenario.floorId, apiScenario.building);
    if (floor) {
      this.totalAvailableUSF = floor.totalFloorUsf;
      this.totalAvailableRSF =
        this.totalAvailableUSF * (1 + apiScenario.rsfLoadFactor);
      this.primaryLabel = floor.name;
      const { startYear: currentYear } = apiScenario;
      const { targetYear } = apiScenario;
      this.compoundLabel =
        targetYear === currentYear
          ? `Current (${targetYear})`
          : `Year ${targetYear - currentYear} (${targetYear})`;
    }
    this.calculationsLabel = 'Floor';
    this.calculationsTitlePrefix = 'Floor';
  }

  static parseFromAnotherCalculatorType(
    scenario: PlainProgramScenario,
    floorId: number
  ) {
    const newScenario = HeadcountScenario.parseToHeadcountScenario(scenario);
    newScenario.floorId = floorId;
    newScenario.calculatorType = GROWTH_CALCULATORS.floorHeadcountSeatcount as CalculatorType;

    return ProgramScenarioFactory.create(
      ProgramScenario.toAPIScenario(newScenario)
    );
  }
}
